import { render, staticRenderFns } from "./CurrencyType.vue?vue&type=template&id=c381532a&"
import script from "./CurrencyType.vue?vue&type=script&lang=js&"
export * from "./CurrencyType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports